import React from 'react';
import AppLink from '../shared/AppLink';

const LodgingCard = ({ lodging, className = "" }) => {
  const slugValue = typeof lodging.slug === 'string'
    ? lodging.slug
    : lodging.slug?.current;
  const priceLabel = lodging.priceRange || '';
  const areaLabel = lodging.area || '';

  return (
    <div className={`flex flex-col h-full w-full min-w-0 max-w-[370px] mx-auto ${className}`}>
      <AppLink to={`/lodging/${slugValue}`} className="block group h-full hover:text-green-300 transition-colors">
        <div className="border border-white/10 rounded-lg overflow-hidden">
          <div
            className="bg-white/5 p-3 flex items-center justify-center text-center"
            style={{
              height: '3.5em',
            }}
          >
            <h3 className="text-lg font-bold leading-tight">
              {lodging.name}
            </h3>
          </div>
          
          <div className="bg-white/5 px-3 py-2 border-t border-white/10">
            <div className="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-2 text-sm whitespace-nowrap">
              <span className="min-w-0 truncate" title={priceLabel}>{priceLabel}</span>
              <span className="min-w-0 truncate text-right" title={areaLabel}>{areaLabel}</span>
            </div>
          </div>

          {lodging.images?.[0]?.asset?.url && (
            <img
              src={lodging.images[0].asset.url}
              alt={lodging.name}
              className="w-full object-cover"
              style={{ aspectRatio: '5/3', maxHeight: 200 }}
              loading="lazy"
            />
          )}
          
          <div className="bg-white/5 p-3 border-t border-white/10" style={{ height: '11em' }}>
            <p className="text-sm leading-tight overflow-hidden">
              {lodging.shortDescription}
            </p>
          </div>
        </div>
      </AppLink>
    </div>
  );
};

export default LodgingCard;

